import { render } from "./ContingentCreatePage.vue?vue&type=template&id=95fc3440"
import script from "./ContingentCreatePage.vue?vue&type=script&lang=js"
export * from "./ContingentCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__